import {
  Component,
  Input,
  OnInit,
  ViewChild,
  HostListener,
  ElementRef,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchStateService } from '@core/services/search-state.service';
import { Ga4Service } from '@core/services/ga4.service';
import { IncrementInputComponent } from '../increment-input/increment-input.component';
import { MbExpandablePanel, MbIcon, MbExpandablePanelTrigger } from '@am/moebius';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'am-expandable-input',
    templateUrl: './am-expandable-input.component.html',
    styleUrls: ['./am-expandable-input.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        MbExpandablePanel,
        NgIf,
        MbIcon,
        IncrementInputComponent,
        FormsModule,
        ReactiveFormsModule,
        MbExpandablePanelTrigger
    ],
})
export class AmExpandableInputComponent implements OnInit {
  @ViewChild('panel') panelDom: any;
  @ViewChild('inputExpandable') inputExpandable: ElementRef;
  @Input() set formGroup(form: UntypedFormGroup) {
    this.formControlInput = form;
  }

  @Input() set formName(name: string) {
    this.formNameInput = name;
  }

  @Input() nameHotel = '';
  public inside = false;
  public formControlInput: UntypedFormGroup;
  public formNameInput = '';

  public visitantes = {
    adultos: 0,
    ninios: 0,
    bebes: 0,
  };

  @HostListener('document:click', ['$event.target'])
  clickedOut(event) {
    if (this.inside && !this.inputExpandable.nativeElement.contains(event)) {
      this.panelDom.expanded = false;
      this.inside = false;
    }
  }

  constructor(
    private fb: UntypedFormBuilder,
    private searchStateService: SearchStateService,
    private ga4Service: Ga4Service,
  ) {
    this.visitantes.adultos = 0;
    this.visitantes.ninios = 0;
    this.visitantes.bebes = 0;
  }

  ngOnInit() {
    this.createForm();
    this.formControlInput.valueChanges.subscribe((response) => {
      this.visitantes.adultos = response.adults;
      this.visitantes.ninios = response.childs;
      this.visitantes.bebes = response.babys;

      const dataGa4 = {
        element: `visitante :: ${this.visitantes.adultos} // ${this.visitantes.ninios}// ${this.visitantes.bebes}`,
        section: this.nameHotel,
        action: 'select',
      };
      this.ga4Service.user_interaction(dataGa4);
    });

    const decodeRooms = this.searchStateService.getDecodedRooms();
    this.visitantes.adultos = decodeRooms.totalAdults;
    decodeRooms.rooms.forEach((room) => {
      room.children.forEach((children) => {
        if (children >= 2) {
          this.visitantes.ninios = this.visitantes.ninios + 1;
        }
        if (children < 2) {
          this.visitantes.bebes = this.visitantes.bebes + 1;
        }
      });
    });
    this.createForm();
  }

  openPanel() {
    this.panelDom.expanded = !this.panelDom.expanded;
    setTimeout(() => {
      if (this.inside === false && this.panelDom.expanded === true) {
        this.inside = true;
      } else if (this.inside === true && this.panelDom.expanded === false) {
        this.inside = false;
      }
    }, 10);
  }

  createForm() {
    this.formControlInput = this.fb.group({
      adults: [this.visitantes.adultos],
      childs: [this.visitantes.ninios],
      babys: [this.visitantes.bebes],
    });
  }
}
